import React from "react"
import Helmet from "react-helmet"
import config from "../../data/SiteConfig"
import Header from "../components/Header/index"
import Footer from "../components/Footer/index"
import "../../static/fonts/Open-Sans WebFonts/stylesheet.css"
import "bootstrap/dist/css/bootstrap.css"
import "font-awesome/css/font-awesome.css"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.min.css"

import "./index.css"

export default class Layout extends React.Component {
  render() {
    const { children } = this.props
    return (
      <div>
        <ToastContainer />
        <Helmet>
          <meta name="description" content={config.siteDescription} />
        </Helmet>
        <Header />
        {children}
        <Footer />
      </div>
    )
  }
}
